import { render, staticRenderFns } from "./LawCounterPartyTypeList.vue?vue&type=template&id=4d695ddd&"
import script from "./LawCounterPartyTypeList.vue?vue&type=script&lang=js&"
export * from "./LawCounterPartyTypeList.vue?vue&type=script&lang=js&"
import style0 from "./LawCounterPartyTypeList.vue?vue&type=style&index=0&id=4d695ddd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports